export const NAVIGATION_NEXT_CLASS_NAME_HOTEL = "swiper-navigation-hotel-next";
export const NAVIGATION_PREV_CLASS_NAME_HOTEL = "swiper-navigation-hotel-prev";
